export const HubsEmbedLibs = {
  defined: true
};

export default HubsEmbedLibs;
